"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TextInput", {
  enumerable: true,
  get: function () {
    return _TextInput.default;
  }
});
Object.defineProperty(exports, "TextInputPropTypes", {
  enumerable: true,
  get: function () {
    return _TextInputPropTypes.default;
  }
});
var _TextInput = _interopRequireDefault(require("./TextInput"));
var _TextInputPropTypes = _interopRequireDefault(require("./TextInputPropTypes"));